import { ReactNode } from 'react';
import { IndexPageRedirect } from '@/components/IndexPageRedirect';
import { useFeatureFlags } from '@/hooks/useFeatureFlags';
import { FeatureFlagName } from '@/utils/featureFlags';

export const RequireFeatureFlag = ({ flag, children }: { flag: FeatureFlagName; children: ReactNode }) => {
  const { areFeatureFlagsLoaded, isFeatureEnabled } = useFeatureFlags();

  if (!areFeatureFlagsLoaded || !isFeatureEnabled(flag)) {
    return <IndexPageRedirect />;
  }

  return <>{children}</>;
};
